import { get, isNil } from 'lodash';

import { activityTypes } from 'constants/activities';
import { affiliateIds } from 'constants/affiliates';
import { kinzeBluevantageId } from '../constants/devices';
import { isScriptTypePlanting } from '../scripts/selectors';
import { createSelector } from '@reduxjs/toolkit';

export const getDeviceList = (state) => get(state, 'devices');
export const getDevicesByName = (state) => get(state, 'devices.byName', {});
export const getDevicesById = (state) => get(state, 'devices.byId', {});
export const getDeviceByName = (state, deviceName) => getDevicesByName(state)[deviceName] || {}; // some of the file names have dots in them that b0rk up lodash's access method
export const getDeviceById = (state, deviceId) => get(getDevicesById(state)[deviceId],'en-us', {}); // currently these devices only exist for en-us
export const getPreferredDevice = (state) => get(state, 'devices.preferred', {});
export const getPreferredDeviceId = (state) => getPreferredDevice(state).value;
export const getPreferredDeviceIdForBulkSendToAffiliate = (state, affiliateId) => {
  return affiliateId === affiliateIds.MYJD ? 'john-deere-gs2-gs3-rx-shapefile' : 'shapefile';
};
export const hasPreferredDevice = (state) => !!getPreferredDeviceId(state);
export const getDriveDevices = (state) => get(state, 'devices.drive', []);
export const getIsKinzeDevice = (state) => {
  const preferredDevice = getPreferredDevice(state);
  if(isNil(preferredDevice)) {
    return false;
  }

  return preferredDevice.value === kinzeBluevantageId;
};
export const getPreferredDeviceForScriptType = createSelector([
  state => isScriptTypePlanting(state),
  state => getIsKinzeDevice(state),
  state => getPreferredDevice(state)
],
(isPlantingScript, isKinzeDevice, preferredDevice) => {
  if (!isPlantingScript && isKinzeDevice) {
    return null;
  }
  return preferredDevice;
});
export const getDevicesForScriptType = createSelector([
  state => getDevicesByName(state),
  state => isScriptTypePlanting(state)
],
(devices, isPlanting) => {
  if(isNil(devices)) {
    return [];
  }

  if(isPlanting) {
    return Object.values(devices);
  }

  return Object.values(devices).filter(x => x.value !== kinzeBluevantageId);
});
export const getPreferredDeviceForActivityType = (state, activityType) =>{
  const isPlanting = activityType === activityTypes.PLANTING;
  const isKinzeDevice = getIsKinzeDevice(state);

  if(!isPlanting && isKinzeDevice) {
    return null;
  }

  return getPreferredDevice(state);
};
